import { render, staticRenderFns } from "./AffDashboard.vue?vue&type=template&id=24293fba&scoped=true&"
import script from "./AffDashboard.vue?vue&type=script&lang=js&"
export * from "./AffDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24293fba",
  null
  
)

export default component.exports